import React from "react";
import { eventChannel } from "redux-saga";
import { push } from "react-router-redux";
import {
  all,
  fork,
  takeLatest,
  put,
  call,
  take,
  select,
} from "redux-saga/effects";
import { authApi } from "../../api/index";
import {
  AuthActionTypes,
  BetSlipActionTypes,
  RegisterActionTypes,
  MembersActionTypes,
  SignalRTypes,
  AppActionTypes,
  GeneralActionTypes,
} from "../actions";
import {
  Cookies,
  Events,
  Utils,
  AppConfig,
  SessionStorage,
} from "../../helpers";
import NoActivityModal from "../../components/common/NoActivityModal";

export function* requests() {
  let tokenChannel = null;
  let tokenTimeout = null;

  function clearCookies() {
    Cookies.remove("token");
    Cookies.remove("memberId");
    Cookies.remove("user");
    //Cookies.remove("tokenExpiresMinutes");
    Cookies.remove("jackpotId");
    Cookies.remove("refreshToken");
    Cookies.remove("expTokenDateTime");
    Cookies.remove("isNotificationMuted");
  }

  function extendCookiesLife() {
    const refreshToken = Cookies.get("refreshToken");
    const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
    const jackpotId = Cookies.get("winnerJackpotId");

    // const memberId = Cookies.get("memberId");
    // const user = Cookies.get("user");
    // Cookies.set("token", token, tokenExpiresMinutes);
    // Cookies.set("memberId", memberId, tokenExpiresMinutes);
    // Cookies.set("user", user, tokenExpiresMinutes);
    // Cookies.set("tokenExpiresMinutes", tokenExpiresMinutes);
    if (refreshToken) {
      Cookies.set("refreshToken", refreshToken, tokenExpiresMinutes);
    }
    if (jackpotId) {
      Cookies.set("winnerJackpotId", jackpotId, 60 * 24);
    }
  }

  function handleTokenExpiresOnClick(emitter) {
    // const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
    // const timeoutExpires = tokenExpiresMinutes * 60000;
    const timeOutMinutes = Cookies.get("timeOutMinutes");
    const timeoutExpires = timeOutMinutes * 60000;
    // const token = Cookies.get("token");
    // const memberId = Cookies.get("memberId");

    // if (!token || !memberId) {
    if (!timeOutMinutes) {
      //emitter({ name: 'timeout' })
    } else {
      extendCookiesLife();
      clearTimeout(tokenTimeout);
      tokenTimeout = setTimeout(() => {
        emitter({ name: "timeout" });
      }, timeoutExpires - 35000);
    }
  }

  function* tokenChannelCreate() {
    try {
      return yield eventChannel((emitter) => {
        Events.subscribe("onTokenExpired", (e) => {
          emitter({ name: "signout", tokenExpired: true });
        });

        Events.subscribe("signout", (e) => {
          emitter({ name: "signout", noActivity: e || false });
        });

        Events.subscribe("refreshToken", (e) => {
          emitter({ name: "refreshToken" });
        });

        clearTimeout(tokenTimeout);
        const tokenExpiresMinutes = Cookies.get("timeOutMinutes");
        const timeoutExpires = tokenExpiresMinutes * 60 * 1000;
        window.log(timeoutExpires);
        tokenTimeout = setTimeout(() => {
          emitter({ name: "timeout" });
        }, timeoutExpires - 35000);

        let authListener = () => {
          handleTokenExpiresOnClick(emitter);
        };
        document.addEventListener("click", authListener);
        return () => {
          Events.unSubscribe("refreshToken");
          clearTimeout(tokenTimeout);
          document.removeEventListener("click", authListener);
        };
      });
    } catch (e) {
      window.log("ERROR", e);
    }
  }

  function tokenChannelClose() {
    if (tokenChannel) {
      tokenChannel.close();
      tokenChannel = null;
    }
  }

  yield takeLatest(AuthActionTypes.Signin_Request, function*(userData) {
    //call server
    try {
      let response = yield authApi.signin(userData.data);

      switch (response.status) {
        case 1:
          let data = response.data.member;
          if (data.isSignedIn) {
            //show pop confirm login
            yield put({
              type: AuthActionTypes.Set_Show_Login_Pop_Confirm,
              value: true,
            });
          } else {
            let token = response.data.token;
            const tokenExpiresMinutes = token.tokenExpiresMinutes;
            //  Cookies.get("expTokenDateTime")
            console.log("!token", token);
            console.log("!tokenExpiresMinutes", tokenExpiresMinutes);

            yield Cookies.set("token", token.token, tokenExpiresMinutes);
            yield Cookies.set(
              "expTokenDateTime",
              token.expDateTime,
              token.tokenExpiresMinutes
            );
            yield Cookies.set(
              "refreshToken",
              token.refreshToken,
              token.tokenExpiresMinutes
            );
            yield Cookies.set("tokenExpiresMinutes", token.tokenExpiresMinutes);
            yield Cookies.set("memberId", data.memberId);
            yield Cookies.set("timeOutMinutes", data.timeOutMinutes);
            yield Cookies.set(
              "isNotificationMuted",
              response.data.member.isNotificationMuted
            );
            if (response.data && response.data.memberFavorites) {
              let data = [];
              response.data.memberFavorites.map((item) => {
                data.push({
                  favoriteId: item.favoriteId,
                  entityType:
                    item.favoriteType && item.favoriteType.favoriteTypeId,
                  entityId: item.elementId,
                  sportId: item.sportId,
                  key: `${item.favoriteType &&
                    item.favoriteType.favoriteTypeId}-${item.elementId}-${
                    item.sportId
                  }`,
                  feedId: item.feedId,
                });
              });
              let favoriteEntities = data.map((item) => {
                return {
                  entityType: item.entityType,
                  entityId: item.entityId,
                  feedId: item.feedId,
                  sportId: item.sportId,
                };
              });
              localStorage.setItem("memberFavorites", JSON.stringify(data));
              localStorage.setItem(
                "favoriteEntities",
                JSON.stringify(favoriteEntities)
              );
            }

            // if (response.data.jackpotPendingWinning) {
            //     yield Cookies.set("jackpotId", response.data.jackpotPendingWinning.jackpotId)
            //     yield put({ type: SignalRTypes.Jackpot_Winning_Approved, jackpotWinningApproved: true })
            // }

            let balances = data.memberBalances.reduce((acc, current) => {
              let currencyName = current.currency.currencyName
                .split(" ")
                .join("");
              if (!acc[currencyName]) {
                acc[currencyName] = {
                  balance: current.balance,
                  currencyId: current.currency.currencyId,
                  currencySymbol: current.currency.currencySymbol,
                  defaultCurrency: current.currency.currencyIsDefault,
                  currencyName: current.currency.currencyName,
                };
              }
              return acc;
            }, {});
            let currency = Object.keys(balances).find((currency) => {
              return balances[currency].defaultCurrency;
            });
            yield Cookies.set("selectedCurrency", balances[currency]);
            yield put({
              type: MembersActionTypes.Set_Selected_Currency,
              currency: balances[currency],
            });
            // console.log("data sign in", response.data);
            yield Cookies.set("user", {
              userName: data.userName,
              firstName: data.firstName,
              lastName: data.lastName,
              email: data.email,
              balance: balances,
              bonus: data.memberDepositBonusBalance,
              memberPhones: response.data.memberPhones,
            });
            if (userData.register) {
              yield put({ type: AuthActionTypes.Register_Signin_Success });
            } else {
              yield put({ type: AuthActionTypes.Signin_Success, data });
            }
            let slotsOpenRound = response.data.slotsOpenRound;

            if (slotsOpenRound && slotsOpenRound.gameId > 0) {
              let modal = {
                key: "roundNotFinish",
                type: "text",
                text: slotsOpenRound.gameMessage,
                visible: true,
                textClassName: "modal-not-finish-text",

                onOK: () => {
                  Utils.closeModal({ id: "roundNotFinish" });
                  Utils.navigateTo(`/slots/game/${slotsOpenRound.gameId}`);
                },
                okLabel: `Back to ${slotsOpenRound.gameName}`,
                cancelLabel: "Cancel",
                onCancel: () => {
                  Utils.closeModal({ id: "roundNotFinish" });
                },
              };
              Utils.openModal(modal);
            }
          }
          break;
        case 3 || 4:
          yield put({
            type: AuthActionTypes.Signin_Error,
            message: response.message,
          });
          break;
        default:
          break;
      }
    } catch (error) {
      window.log("client ==>> could not sign in");
    }
  });

  yield takeLatest(AuthActionTypes.Signin_Success, function*() {
    try {
      yield put({
        type: AppActionTypes.ChangeFeed,
        feedId: "6",
        feedName: "sport",
      });
      yield put({ type: BetSlipActionTypes.Set_Login_Error, loginError: "" });
      yield put({ type: AuthActionTypes.Start_Click_listener });
      if (AppConfig.booongoSRAddress) {
        yield put({ type: SignalRTypes.Booongo_Connect_Request });
      }

      if (AppConfig.memberChangeSRAddress) {
        yield put({ type: SignalRTypes.Member_Change_Connect_Request });
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeLatest(AuthActionTypes.Start_Click_listener, function*() {
    const { register } = yield select();
    if (!tokenChannel) {
      tokenChannel = yield call(tokenChannelCreate);
      yield window.log("Service START: Token Service");
    }
    while (true) {
      const event = yield take(tokenChannel);
      if (event.name === "signout") {
        if (register.formData.phone) {
          yield put({ type: RegisterActionTypes.Init });
        }
        yield put({
          type: AuthActionTypes.Signout_Request,
          noActivity: event.noActivity,
          tokenExpired: event.tokenExpired,
        });
        clearTimeout(tokenTimeout);
      }
      if (event.name === "timeout") {
        if (document.hidden) {
          yield put({
            type: AuthActionTypes.Signout_Request,
            noActivity: true,
          });
          clearTimeout(tokenTimeout);
        } else {
          const noActivityModal = (
            <NoActivityModal
              text="You have been not active for a while, member will be signed out in"
              time={30}
              okLabel="Stay Connected"
              onOK={() => {
                Events.publish("refreshToken");
                Utils.closeModal({ id: "memberTimeOut" });
              }}
              onTimeoutFinished={() => {
                Events.publish("signout", true);
                Utils.closeModal({ id: "memberTimeOut" });
              }}
            />
          );

          let modal = {
            key: "memberTimeOut",
            type: "custom",
            children: noActivityModal,
            visible: true,
          };
          Utils.openModal(modal);
          clearTimeout(tokenTimeout);
        }
      }
      if (event.name === "refreshToken") {
        console.log("!auth sage refresh token");
        const token = { refreshToken: Cookies.get("refreshToken") };
        console.log("!token", token);
        yield put({ type: AuthActionTypes.Refresh_Token_Request, data: token });
      }
    }
  });

  yield takeLatest(AuthActionTypes.Signout_Request, function*({
    noActivity,
    tokenExpired,
  }) {
    //call server

    try {
      if (!tokenExpired) {
        let memberId = Cookies.get("memberId");
        if (memberId == null) {
          memberId = Cookies.get("memberId");
        }
        if (memberId == null) {
          yield put({ type: AuthActionTypes.Signout_Success });
        } else {
          let response = yield authApi.signout({ id: memberId });
          switch (response.status) {
            case 1:
              yield put({ type: AuthActionTypes.Signout_Success, response });
              yield put(push("/"));
              if (noActivity) {
                Utils.closeModal({ id: "memberTimeOut" });
                let modal = {
                  key: "memberSignedOut",
                  type: "text",
                  text:
                    "You have been not active for a while, you were signed out",
                  visible: true,
                  onOK: () => Utils.closeModal({ id: "memberSignedOut" }),
                  okLabel: "OK",
                };
                Utils.openModal(modal);
              }
              break;
            case 3 || 4:
              yield put({
                type: AuthActionTypes.Signout_Error,
                message: response.message,
              });
              break;
          }
        }
      } else {
        yield put(push("/"));
        yield put({ type: AuthActionTypes.Signout_Success });

        let modal = {
          key: "tokenExpired",
          text: "Your token was expired, please sign in again.",
          type: "text",
          onOK: () => {
            Utils.closeModal({ id: "tokenExpired" });
          },
          okLabel: "Ok",
        };

        Utils.openModal(modal);
      }
    } catch (error) {
      window.log("client ==>> could not sign out");
    }
  });

  yield takeLatest(AuthActionTypes.Signout_Success, function*() {
    try {
      localStorage.removeItem("memberFavorites");
      localStorage.removeItem("favoriteEntities");
      SessionStorage.betSlipCouponId = false;
      SessionStorage.couponCodeText = false;
      SessionStorage.couponCode = false;
      yield clearCookies();
      yield put({ type: AuthActionTypes.Init });
      yield put({ type: MembersActionTypes.Init });
      yield put({ type: RegisterActionTypes.Init });
      yield put({ type: GeneralActionTypes.Get_Currencies_Request }); //GET general currencies after user signout
      yield put({ type: SignalRTypes.Booongo_Disconnect_Request });
      yield put({ type: SignalRTypes.Member_Change_Disconnect_Request });

      Events.unSubscribe("onTokenExpired");
      yield tokenChannelClose();

      yield put({
        type: AppActionTypes.ChangeFeed,
        feedId: "6",
        feedName: "sport",
      });
    } catch (e) {
      window.log("ERROR", e);
    }
  });

  yield takeLatest(
    AuthActionTypes.Forgot_Password_Check_Dest_Request,
    function*(userName) {
      //call server
      try {
        let response = yield authApi.forgotPasswordCheckDestination({
          name: userName.data,
        });
        let data = response.data;
        switch (response.status) {
          case 1:
            yield put({
              type: AuthActionTypes.Forgot_Password_Check_Dest_Suceess,
              data,
              message: response.message,
            });
            break;
          case 3 || 4:
            yield put({
              type: AuthActionTypes.Forgot_Password_Check_Dest_Error,
              message: response.message,
            });
            break;
        }
      } catch (error) {
        window.log(
          "client ==>> could not request forgot password check destination"
        );
      }
    }
  );

  yield takeLatest(AuthActionTypes.Forgot_Password_Request, function*(
    userData
  ) {
    //call server
    try {
      let response = yield authApi.forgotPassword(userData.data);
      let data = response.data;
      switch (response.status) {
        case 1:
          yield put({
            type: AuthActionTypes.Forgot_Password_Suceess,
            data,
            message: response.message,
          });
          yield put({
            type: AuthActionTypes.Forgot_Password_First_Step_Confirm_Suceess,
          });
          break;
        case 3 || 4:
          yield put({
            type: AuthActionTypes.Forgot_Password_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client ==>> could not request forgot password");
    }
  });

  yield takeLatest(AuthActionTypes.Forgot_Password_Confirm_Request, function*(
    userData
  ) {
    //call server
    try {
      const { auth } = yield select();
      let response = yield authApi.forgotPasswordConfirm(userData.data);
      switch (response.status) {
        case 1:
          let current = auth.currentForgotPassword + 1;
          yield put({
            type: AuthActionTypes.Forgot_Password_Confirm_Suceess,
            current,
          });
          break;
        case 3 || 4:
          yield put({
            type: AuthActionTypes.Forgot_Password_Confirm_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client ==>> could not request forgot password confirm");
    }
  });

  yield takeLatest(AuthActionTypes.Change_Password_Request, function*(
    userData
  ) {
    //call server
    try {
      let response = yield authApi.changePassword(userData.data);
      switch (response.status) {
        case 1:
          yield put({
            type: AuthActionTypes.Change_Password_Suceess,
            message: response.message,
          });
          break;
        case 3 || 4:
          yield put({
            type: AuthActionTypes.Change_Password_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client ==>> could not request change password");
    }
  });

  yield takeLatest(AuthActionTypes.Update_Password_Request, function*({
    data,
  }) {
    //call server
    try {
      let response = yield authApi.updatePassword(data);
      switch (response.status) {
        case 1:
          yield put({ type: AuthActionTypes.Update_Password_Suceess });
          break;
        case 3 || 4:
          yield put({
            type: AuthActionTypes.Update_Password_Error,
            message: response.message,
          });
          break;
      }
    } catch (error) {
      window.log("client ==>> could not request update password");
    }
  });

  const { auth } = yield select();
  if (auth.signedIn) {
    yield put({ type: AuthActionTypes.Start_Click_listener });
    extendCookiesLife();
  }
}
export default function* AuthSaga() {
  yield all([fork(requests)]);
}
